/** SHD Horizon diode filter + hide unavailable variants (not labeled Unavailable). */
(function () {
  var NON_DIODE_CORE = [
    "Mirror Acrylic",
    '1/8" & 1/16" Mirror Acrylic',
    '1/8" Cosmic Kisses',
    '1/8" Neon Acrylic',
    '1/8" Solar Flare Acrylic',
    '1/8" Glow in the Dark Acrylic',
    '1/8" Iridescent Acrylic',
    '1/8" Standard Glitter Acrylic',
    "Clear Acrylic",
    '1/8" Clear Acrylic',
    '1/8" White Acrylic',
    '1/8" Frosted Clear'
  ];
  var NON_DIODE_COLOR = [
    "White",
    "Clear",
    "Aqua",
    "Blue",
    "Golden Yellow",
    "Ivory",
    "Orange",
    "Turquoise",
    "Silver Mirror",
    "Matte White",
    "Frosted Clear",
    "Iridescent Celestial Prism"
  ];

  var isShowingDiodeFriendly = false;
  var applying = false;
  var pollId = null;
  var reapplyTimer = null;
  var toggleLock = false;
  var unavailTimer = null;

  /** select -> [{ clone, index, value }] while diode ON */
  var store = typeof WeakMap !== "undefined" ? new WeakMap() : null;
  var storeFallback = [];

  function getSelects() {
    return Array.prototype.slice.call(
      document.querySelectorAll("select.variant-option__select")
    );
  }

  function isArtScene(selects) {
    var s0 = selects[0];
    return !!(s0 && s0.value && String(s0.value).toLowerCase().indexOf("squares") !== -1);
  }

  function coreSelect(selects) {
    return isArtScene(selects) ? selects[1] : selects[0];
  }

  function colorSelect(selects) {
    return isArtScene(selects) ? selects[2] : selects[1];
  }


  /** Alphabetical / natural-ish sort for color <option>s; keep placeholders first; preserve selection. */
  function sortColorOptionsAlpha(select) {
    if (!select || !select.options || select.options.length < 3) return;
    var selected = select.value;
    var opts = Array.prototype.slice.call(select.options);
    var placeholders = [];
    var rest = [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var v = (o.value || "").trim();
      var t = (o.textContent || "").replace(/\s+/g, " ").trim();
      var isPh =
        !v ||
        o.disabled && /select an option/i.test(t) ||
        /^select(\s+an)?\s+option$/i.test(t) ||
        /^choose/i.test(t);
      if (isPh) placeholders.push(o);
      else rest.push(o);
    }
    rest.sort(function (a, b) {
      var ta = (a.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var tb = (b.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      // strip trailing " - Unavailable" for sort key
      ta = ta.replace(/\s-\sunavailable$/i, "");
      tb = tb.replace(/\s-\sunavailable$/i, "");
      if (ta < tb) return -1;
      if (ta > tb) return 1;
      return 0;
    });
    // SHD 2026-10-16 fix: skip if already sorted. Re-appending options every pass fed the picker
    // MutationObserver -> endless re-sort loop that reset the open dropdown and the shopper's choice.
    var desired = placeholders.concat(rest);
    var inOrder = true;
    for (var d = 0; d < desired.length; d++) {
      if (opts[d] !== desired[d]) { inOrder = false; break; }
    }
    if (inOrder) return;
    var frag = document.createDocumentFragment();
    placeholders.concat(rest).forEach(function (o) {
      frag.appendChild(o);
    });
    select.appendChild(frag);
    if (selected) {
      try {
        select.value = selected;
      } catch (e) {}
    }
  }

  function sortAllColorSelects() {
    var selects = getSelects();
    var col = colorSelect(selects);
    if (col) sortColorOptionsAlpha(col);
  }

  /** Cached /products/{handle}.js — used to rebuild empty/invalid option selects after morph. */
  var productJson = null;
  var productJsonLoading = false;
  var productJsonQueued = null;

  function productHandle() {
    try {
      var path = (location.pathname || "").split("?")[0];
      var m = path.match(/\/products\/([^\/]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function loadProductJson(cb) {
    if (productJson) {
      cb(productJson);
      return;
    }
    if (productJsonLoading) {
      productJsonQueued = cb;
      return;
    }
    var handle = productHandle();
    if (!handle || typeof fetch === "undefined") {
      cb(null);
      return;
    }
    productJsonLoading = true;
    fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin"
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        productJson = data;
        productJsonLoading = false;
        cb(data);
        if (productJsonQueued) {
          var q = productJsonQueued;
          productJsonQueued = null;
          q(data);
        }
      })
      .catch(function () {
        productJsonLoading = false;
        cb(null);
        if (productJsonQueued) {
          var q = productJsonQueued;
          productJsonQueued = null;
          q(null);
        }
      });
  }

  function optionKey(idx) {
    return "option" + (idx + 1);
  }

  function selectOptionIndex(select, selects) {
    var i = selects.indexOf(select);
    return i >= 0 ? i : 0;
  }

  function currentOptionValues(selects) {
    return selects.map(function (s) {
      return s && s.value ? s.value : "";
    });
  }

  function variantMatchesOthers(variant, optionIndex, values) {
    for (var i = 0; i < values.length; i++) {
      if (i === optionIndex) continue;
      var want = values[i];
      if (!want) continue;
      var got = variant[optionKey(i)];
      if (got != null && String(got) !== String(want)) return false;
    }
    return true;
  }

  function validValuesForOption(product, optionIndex, values) {
    var out = [];
    var seen = {};
    if (!product || !product.variants) return out;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v || !v.available) continue;
      if (!variantMatchesOthers(v, optionIndex, values)) continue;
      var val = v[optionKey(optionIndex)];
      if (val == null || val === "") continue;
      var key = String(val);
      if (seen[key]) continue;
      seen[key] = true;
      out.push(String(val));
    }
    return out;
  }

  function isSidedSelect(select) {
    if (!select) return false;
    var name = (select.getAttribute("name") || "") + " " + (select.id || "");
    var label = "";
    try {
      var root = select.closest ? select.closest(".variant-option") : null;
      var lab = root && root.querySelector ? root.querySelector("label") : null;
      label = lab && lab.textContent ? lab.textContent : "";
    } catch (e) {}
    return /side/i.test(name + " " + label);
  }

  function selectHasMorphFallback(select) {
    if (!select) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].getAttribute("data-shd-morph-fallback") === "1") return true;
    }
    return false;
  }

  function findVariantForValues(product, values) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v || !v.available) continue;
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (!values[j]) continue;
        if (String(v[optionKey(j)]) !== String(values[j])) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  /**
   * Prefer pruning existing <option> nodes so data-option-value-id /
   * data-variant-id from Liquid survive — Horizon morph needs those IDs.
   * Only synthesize nodes if the select is empty (no IDs available).
   */
  function rebuildSelectOptions(select, values, preferValue, product, optionIndex, otherValues) {
    if (!select || !values || !values.length) return false;
    var prev = select.value;
    var keep =
      preferValue && values.indexOf(preferValue) !== -1
        ? preferValue
        : prev && values.indexOf(prev) !== -1
          ? prev
          : values[0];

    var validSet = {};
    for (var i = 0; i < values.length; i++) validSet[String(values[i])] = true;

    if (select.options.length) {
      // Prune invalid / fallback options; keep Liquid attributes on survivors
      for (var j = select.options.length - 1; j >= 0; j--) {
        var opt = select.options[j];
        if (!validSet[String(opt.value)]) {
          try {
            if (typeof opt.remove === "function") opt.remove();
            else if (opt.parentNode) opt.parentNode.removeChild(opt);
          } catch (err) {}
        } else {
          opt.removeAttribute("data-shd-morph-fallback");
          opt.setAttribute("data-option-available", "true");
        }
      }
    }

    // If still missing some valid values and select was empty, synthesize
    var have = {};
    Array.prototype.forEach.call(select.options, function (o) {
      have[String(o.value)] = true;
    });
    for (var k = 0; k < values.length; k++) {
      if (have[String(values[k])]) continue;
      var node = document.createElement("option");
      node.value = values[k];
      node.textContent = values[k];
      node.setAttribute("data-option-available", "true");
      if (product) {
        var trial = otherValues ? otherValues.slice() : [];
        trial[optionIndex] = values[k];
        var match = findVariantForValues(product, trial);
        if (match && match.id) node.setAttribute("data-variant-id", String(match.id));
      }
      select.appendChild(node);
      have[String(values[k])] = true;
    }

    if (!select.options.length) return false;

    select.value = keep;
    Array.prototype.forEach.call(select.options, function (o) {
      if (o.value === keep) o.setAttribute("selected", "selected");
      else o.removeAttribute("selected");
    });
    // Ensure variant id present on kept option when possible
    if (product) {
      var kept = select.options[select.selectedIndex];
      if (kept && !kept.getAttribute("data-variant-id")) {
        var trial2 = otherValues ? otherValues.slice() : [];
        trial2[optionIndex] = keep;
        var match2 = findVariantForValues(product, trial2);
        if (match2 && match2.id) kept.setAttribute("data-variant-id", String(match2.id));
      }
    }
    return true;
  }

  /**
   * After Horizon morph + unavailable skip, a select (often 1/2-Sided) can be empty
   * or filled with morph-fallback values. Rebuild from available product.js variants
   * matching the other current selections, then auto-select a valid value.
   */
  function repairInvalidOptionSelects(product) {
    if (!product) return [];
    var selects = getSelects();
    if (!selects.length) return [];
    var values = currentOptionValues(selects);
    var changed = [];
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      var valid = validValuesForOption(product, i, values);
      if (!valid.length) continue;
      var empty = !select.options.length;
      var fallback = selectHasMorphFallback(select);
      var cur = select.value;
      var invalid = !cur || valid.indexOf(cur) === -1;
      // Only repair empty/fallback selects, or an invalid SIDED select.
      // Never rewrite Core/Color just because the current combo is mid-morph invalid —
      // that reverts the shopper's core choice back to Acrylic.
      var sided = isSidedSelect(select);
      if (empty || fallback) {
        /* repair */
      } else if (sided && invalid) {
        /* repair sided only */
      } else {
        continue;
      }
      rebuildSelectOptions(select, valid, cur, product, i, values);
      // refresh values for subsequent option indices
      values[i] = select.value;
      changed.push(select);
      // sync hidden variant id inputs immediately
      syncVariantId();
    }
    return changed;
  }

  var resyncTimer = null;

  function pickerVariantJson() {
    try {
      var script = document.querySelector("variant-picker script[type='application/json']");
      if (!script || !script.textContent) return null;
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  // SHD 2026-10-19 fix: a variant fetch is in flight (variant:selected seen, no variant:update yet).
  // ATC is disabled on purpose during that time; re-firing change here aborted the fetch and restarted it
  // every ~450ms on slower connections -> endless loop, flashing/disabled Add to cart.
  var variantPendingSince = 0;
  function variantFetchPending() {
    return variantPendingSince && Date.now() - variantPendingSince < 8000;
  }

  function needsVariantResync() {
    if (variantFetchPending()) return false;
    var selects = getSelects();
    if (!selects.length) return false;
    var allChosen = true;
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value || !selects[i].options.length) {
        allChosen = false;
        break;
      }
    }
    if (!allChosen) return false;
    var data = pickerVariantJson();
    if (!data || data.available === false) return true;
    var atc = document.querySelector('button[name="add"]');
    if (atc && atc.disabled) return true;
    return false;
  }

  function scheduleVariantResync() {
    // Do NOT reset an already-queued resync — MutationObserver morph chatter
    // would otherwise postpone it forever and leave ATC on Unavailable.
    if (resyncTimer) return;
    resyncTimer = setTimeout(function () {
      resyncTimer = null;
      if (applying) {
        scheduleVariantResync();
        return;
      }
      if (!needsVariantResync()) return;
      var selects = getSelects();
      if (!selects.length) return;
      var target = null;
      for (var i = selects.length - 1; i >= 0; i--) {
        if (isSidedSelect(selects[i])) {
          target = selects[i];
          break;
        }
      }
      fireChange(target || selects[selects.length - 1]);
      // One follow-up in case the first morph was still settling
      setTimeout(function () {
        if (!applying && needsVariantResync()) {
          var sels = getSelects();
          if (!sels.length) return;
          var t = null;
          for (var j = sels.length - 1; j >= 0; j--) {
            if (isSidedSelect(sels[j])) {
              t = sels[j];
              break;
            }
          }
          fireChange(t || sels[sels.length - 1]);
        }
      }, 500);
    }, 450);
  }

  function scheduleProductRepair() {
    loadProductJson(function (product) {
      if (!product || applying) return;
      var changed = repairInvalidOptionSelects(product);
      if (!changed.length) return;
      hideUnavailableCustomUi();
      fireChange(changed[changed.length - 1]);
      sortAllColorSelects();
    });
  }

  function matchVal(value, list) {
    return list.indexOf(value) !== -1;
  }

  function match(opt, list) {
    return !!(opt && matchVal(opt.value, list));
  }

  function getStore(select) {
    if (store) return store.get(select) || [];
    for (var i = 0; i < storeFallback.length; i++) {
      if (storeFallback[i].select === select) return storeFallback[i].items;
    }
    return [];
  }

  function setStore(select, items) {
    if (store) {
      store.set(select, items);
      return;
    }
    for (var i = 0; i < storeFallback.length; i++) {
      if (storeFallback[i].select === select) {
        storeFallback[i].items = items;
        return;
      }
    }
    storeFallback.push({ select: select, items: items });
  }

  function isUnavailableOption(opt) {
    if (!opt) return false;
    if (opt.getAttribute("data-option-available") === "false") return true;
    var t = (opt.textContent || "").replace(/\s+/g, " ").trim();
    // Horizon locales append " - Unavailable" (and similar)
    if (/\s-\sUnavailable$/i.test(t)) return true;
    if (/\s-\sNicht verfügbar$/i.test(t)) return true;
    if (/\s-\sIndisponible$/i.test(t)) return true;
    return false;
  }

  /**
   * Remove matching <option> nodes. Keep clones keyed by select for restore.
   * Always strips any currently-present matches (safe after Horizon morph).
   */
  function detachMatching(select, list) {
    if (!select) return;
    var saved = getStore(select).slice();
    var knownValues = {};
    for (var s = 0; s < saved.length; s++) knownValues[saved[s].value] = true;

    var victims = [];
    Array.prototype.forEach.call(select.options, function (opt, idx) {
      if (!match(opt, list)) return;
      victims.push({ opt: opt, index: idx, value: opt.value });
    });
    if (!victims.length) return;

    for (var i = victims.length - 1; i >= 0; i--) {
      var v = victims[i];
      if (!knownValues[v.value]) {
        saved.push({
          clone: v.opt.cloneNode(true),
          index: v.index,
          value: v.value
        });
        knownValues[v.value] = true;
      }
      try {
        if (typeof v.opt.remove === "function") v.opt.remove();
        else if (v.opt.parentNode) v.opt.parentNode.removeChild(v.opt);
      } catch (err) {}
    }
    setStore(select, saved);
  }

  function restoreDetached(select) {
    if (!select) return;
    var items = getStore(select);
    if (!items || !items.length) return;

    var have = {};
    Array.prototype.forEach.call(select.options, function (opt) {
      have[opt.value] = true;
    });

    items = items.slice().sort(function (a, b) {
      return a.index - b.index;
    });

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || have[item.value]) continue;
      var node = item.clone ? item.clone.cloneNode(true) : null;
      if (!node) continue;
      node.hidden = false;
      node.removeAttribute("hidden");
      node.removeAttribute("data-shd-diode-hidden");
      node.style.display = "";
      node.disabled = false;
      node.removeAttribute("disabled");
      var opts = select.options;
      if (item.index >= opts.length) select.appendChild(node);
      else select.insertBefore(node, opts[item.index]);
      have[item.value] = true;
    }
    setStore(select, []);
  }

  function setCustomUiHidden(list, hide) {
    var nodes = document.querySelectorAll(
      ".variant-option__button-label, .variant-option--buttons label, [data-option-value], [role='option']"
    );
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.closest && el.closest("#predictive-search-results")) return;
      var input = el.querySelector && el.querySelector("input");
      var val =
        (el.getAttribute && el.getAttribute("data-option-value")) ||
        (el.getAttribute && el.getAttribute("data-value")) ||
        (input && input.value) ||
        "";
      if (!val || !matchVal(val, list)) return;
      if (hide) {
        el.style.display = "none";
        el.setAttribute("data-shd-diode-hidden-ui", "1");
        el.setAttribute("hidden", "");
      } else if (el.getAttribute("data-shd-diode-hidden-ui") === "1") {
        el.style.display = "";
        el.removeAttribute("data-shd-diode-hidden-ui");
        el.removeAttribute("hidden");
      }
    });
  }

  /** Hide Horizon unavailable button/swatch UIs (safety net; CSS also hides). */
  function hideUnavailableCustomUi() {
    var nodes = document.querySelectorAll(
      ".variant-option__button-label:has([data-option-available='false']), label:has(input[data-option-available='false'])"
    );
    Array.prototype.forEach.call(nodes, function (el) {
      el.style.display = "none";
      el.setAttribute("data-shd-unavail-hidden-ui", "1");
      el.setAttribute("hidden", "");
      var input = el.querySelector && el.querySelector("input");
      if (input && input.checked) input.checked = false;
    });
  }

  /**
   * REMOVE unavailable <option>s from native selects (Chrome ignores option.hidden).
   * No restore needed — Horizon morph re-renders the full list with updated availability.
   */
  function stripUnavailableOptions(select) {
    if (!select) return false;
    var removed = false;
    var victims = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      if (isUnavailableOption(opt)) victims.push(opt);
    });
    for (var i = victims.length - 1; i >= 0; i--) {
      try {
        if (typeof victims[i].remove === "function") victims[i].remove();
        else if (victims[i].parentNode) victims[i].parentNode.removeChild(victims[i]);
        removed = true;
      } catch (err) {}
    }
    return removed;
  }

  function firstSafe(select, hideList) {
    if (!select) return null;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!opt || !opt.value) continue;
      if (isUnavailableOption(opt)) continue;
      if (hideList && match(opt, hideList)) continue;
      return opt;
    }
    return null;
  }

  function fireChange(select) {
    if (!select) return;
    applying = true;
    try {
      select.dispatchEvent(new Event("change", { bubbles: true }));
      syncVariantId();
    } finally {
      setTimeout(function () {
        applying = false;
      }, 0);
    }
  }

  function ensureSafeSelection(select, hideList) {
    if (!select || select.selectedIndex < 0) return false;
    var cur = select.options[select.selectedIndex];
    if (!cur || !match(cur, hideList)) return false;
    var next = firstSafe(select, hideList);
    if (!next || select.value === next.value) return false;
    select.value = next.value;
    Array.prototype.forEach.call(select.options, function (o) {
      if (o === next) o.setAttribute("selected", "selected");
      else o.removeAttribute("selected");
    });
    return true;
  }

  function ensureSelectionAfterDetach(select) {
    if (!select || !select.options.length) return false;
    var cur = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    var selectedAttr = select.querySelector("option[selected]");
    // Valid browser + attribute selection
    if (cur && cur.value && !isUnavailableOption(cur) && selectedAttr === cur) return false;
    // Browser has a valid option but attribute missing after morph/skip — sync attr only.
    // SHD 2026-10-19 fix: do NOT report a change here. The shown value did not change, and firing
    // change after every morph (a stale [selected] on another option survives the morph) restarted
    // the variant fetch forever -> Add to cart stuck disabled/flashing (e.g. Flex / .01 Frosted Flex).
    if (cur && cur.value && !isUnavailableOption(cur) && selectedAttr !== cur) {
      Array.prototype.forEach.call(select.options, function (o) {
        if (o === cur) o.setAttribute("selected", "selected");
        else o.removeAttribute("selected");
      });
      return false;
    }
    var next = firstSafe(select, null);
    if (!next) return false;
    if (cur && cur.value === next.value && selectedAttr === next) return false;
    select.value = next.value;
    Array.prototype.forEach.call(select.options, function (o) {
      if (o === next) o.setAttribute("selected", "selected");
      else o.removeAttribute("selected");
    });
    return true;
  }

  /** Always-on: strip unavailable options + fix selection if current vanished. */
  function applyUnavailableHide(opts) {
    opts = opts || {};
    var selects = getSelects();
    if (!selects.length) {
      hideUnavailableCustomUi();
      return false;
    }
    var changedSelects = [];
    for (var i = 0; i < selects.length; i++) {
      stripUnavailableOptions(selects[i]);
      if (ensureSelectionAfterDetach(selects[i])) changedSelects.push(selects[i]);
    }
    // Repair empty / morph-fallback / invalid selects (esp. 1/2-Sided) from product.js
    if (productJson) {
      var repaired = repairInvalidOptionSelects(productJson);
      for (var r = 0; r < repaired.length; r++) {
        if (changedSelects.indexOf(repaired[r]) === -1) changedSelects.push(repaired[r]);
      }
    } else if (!opts.skipProductLoad) {
      scheduleProductRepair();
    }
    hideUnavailableCustomUi();
    if (changedSelects.length && !opts.skipChange) {
      // Prefer firing the last changed select (often sided) so variant id syncs
      fireChange(changedSelects[changedSelects.length - 1]);
    }
    sortAllColorSelects();
    if (!opts.skipResync) scheduleVariantResync();
    return changedSelects.length > 0;
  }

  function applyFilter(active, opts) {
    opts = opts || {};
    var selects = getSelects();
    if (!selects.length) return;

    // Unavailable first so diode works on the remaining visible set
    applyUnavailableHide({ skipChange: true });

    var cSel = coreSelect(selects);
    var colSel = colorSelect(selects);
    var changed = false;

    if (active) {
      if (ensureSafeSelection(cSel, NON_DIODE_CORE)) changed = true;
      if (ensureSafeSelection(colSel, NON_DIODE_COLOR)) changed = true;
      detachMatching(cSel, NON_DIODE_CORE);
      detachMatching(colSel, NON_DIODE_COLOR);
      if (ensureSelectionAfterDetach(cSel)) changed = true;
      if (ensureSelectionAfterDetach(colSel)) changed = true;
      setCustomUiHidden(NON_DIODE_CORE, true);
      setCustomUiHidden(NON_DIODE_COLOR, true);
    } else {
      restoreDetached(cSel);
      restoreDetached(colSel);
      // After restore, morph/restore may bring unavailable back — strip again
      applyUnavailableHide({ skipChange: true });
      setCustomUiHidden(NON_DIODE_CORE, false);
      setCustomUiHidden(NON_DIODE_COLOR, false);
    }

    if (changed && !opts.skipChange) {
      fireChange(cSel || selects[0]);
      if (colSel && colSel !== cSel) fireChange(colSel);
    } else if (!opts.silent && opts.forceChange) {
      fireChange(cSel || selects[0]);
    }
    sortColorOptionsAlpha(colSel);
  }

  function ensureToggleMarkup(btn) {
    if (btn.querySelector(".shd-df-switch")) return;
    btn.classList.add("shd-df-toggle");
    btn.innerHTML =
      '<span class="shd-df-switch" aria-hidden="true"><span class="shd-df-knob"></span></span>' +
      '<span class="shd-df-label"></span>';
  }

  function setButtonUi(active) {
    var btn = document.getElementById("btnShowDiodeFriendly");
    var txt = document.getElementById("txtShowDiodeFriendly");
    if (!btn) return;
    if (!btn.classList.contains("button-df")) btn.classList.add("button-df");
    ensureToggleMarkup(btn);
    btn.setAttribute("data-shd-diode-active", active ? "1" : "0");
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var label = btn.querySelector(".shd-df-label");
    var want = active ? "Showing diode friendly options" : "Show me diode friendly options";
    if (label && label.textContent !== want) label.textContent = want;
    if (active) {
      btn.classList.add("button-df-active");
      if (txt) txt.style.display = "none";
    } else {
      btn.classList.remove("button-df-active");
      if (txt) txt.style.display = "";
    }
  }

  function syncVariantId() {
    var selects = getSelects();
    if (!selects.length) return;
    var last = selects[selects.length - 1];
    if (!last || last.selectedIndex < 0) return;
    var opt = last.options[last.selectedIndex];
    if (!opt) return;
    var vid = opt.getAttribute("data-variant-id");
    if (!vid) return;
    Array.prototype.forEach.call(document.querySelectorAll('input[name="id"]'), function (inp) {
      inp.value = vid;
    });
  }

  function needsRedeatch() {
    var selects = getSelects();
    if (!selects.length) return false;
    var cSel = coreSelect(selects);
    var colSel = colorSelect(selects);
    function hasForbidden(select, list) {
      if (!select) return false;
      for (var i = 0; i < select.options.length; i++) {
        if (match(select.options[i], list)) return true;
      }
      return false;
    }
    function hasUnavail(select) {
      if (!select) return false;
      for (var i = 0; i < select.options.length; i++) {
        if (isUnavailableOption(select.options[i])) return true;
      }
      return false;
    }
    function needsRepair(select) {
      if (!select) return false;
      if (!select.options.length) return true;
      if (selectHasMorphFallback(select)) return true;
      if (!select.value) return true;
      return false;
    }
    if (hasUnavail(cSel) || hasUnavail(colSel)) return true;
    for (var i = 0; i < selects.length; i++) {
      if (hasUnavail(selects[i]) || needsRepair(selects[i])) return true;
    }
    if (!isShowingDiodeFriendly) return false;
    return hasForbidden(cSel, NON_DIODE_CORE) || hasForbidden(colSel, NON_DIODE_COLOR);
  }

  function startPoll() {
    if (pollId) return;
    pollId = setInterval(function () {
      if (needsRedeatch()) {
        if (isShowingDiodeFriendly) applyFilter(true, { silent: true, skipChange: true });
        else applyUnavailableHide({ skipChange: true });
      }
      if (isShowingDiodeFriendly) {
        setButtonUi(true);
        rebindButton();
      }
    }, 300);
  }

  function stopPoll() {
    // Keep a light poll for unavailable-after-morph even when diode OFF
    if (!isShowingDiodeFriendly) {
      // still poll via startPoll always-on — don't clear if we want unavail watch
    }
    if (!pollId) return;
    clearInterval(pollId);
    pollId = null;
  }

  function scheduleReapply() {
    if (reapplyTimer) clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(function () {
      reapplyTimer = null;
      if (isShowingDiodeFriendly) {
        applyFilter(true, { silent: true, skipChange: true });
        setButtonUi(true);
        rebindButton();
      } else {
        applyUnavailableHide({ skipChange: false });
      }
    }, 60);
  }

  function scheduleUnavailableOnly() {
    if (unavailTimer) clearTimeout(unavailTimer);
    unavailTimer = setTimeout(function () {
      unavailTimer = null;
      if (isShowingDiodeFriendly) {
        applyFilter(true, { silent: true, skipChange: true });
      } else {
        applyUnavailableHide({ skipChange: false });
      }
      scheduleVariantResync();
    }, 80);
  }

  function toggle(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();
    if (ev && ev.stopPropagation) ev.stopPropagation();
    if (toggleLock) return false;
    toggleLock = true;
    setTimeout(function () {
      toggleLock = false;
    }, 100);

    isShowingDiodeFriendly = !isShowingDiodeFriendly;
    setButtonUi(isShowingDiodeFriendly);
    applyFilter(isShowingDiodeFriendly, { silent: true, skipChange: false });
    syncVariantId();
    startPoll();
    return false;
  }

  window.__SHDDiodeToggle = toggle;
  window.__SHDDiodeApply = function () {
    if (isShowingDiodeFriendly) applyFilter(true, { silent: true, skipChange: true });
    else applyUnavailableHide({ skipChange: true });
  };
  window.__SHDHideUnavailable = function () {
    applyUnavailableHide({ skipChange: false });
  };

  function onDocChange(e) {
    if (applying) return;
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains("variant-option__select")) return;
    // Horizon morphs picker after change — re-strip unavailable (+ diode if ON)
    scheduleReapply();
    // Extra passes while morph settles
    setTimeout(scheduleUnavailableOnly, 200);
    setTimeout(scheduleUnavailableOnly, 500);
  }

  function rebindButton() {
    var btn = document.getElementById("btnShowDiodeFriendly");
    if (!btn) return;
    // Single wiring path: inline onclick only (avoid double-toggle)
    btn.setAttribute("onclick", "return window.__SHDDiodeToggle(event)");
    btn.setAttribute("data-shd-diode-bound", "1");
    setButtonUi(isShowingDiodeFriendly);
  }

  function observePicker() {
    var root = document.querySelector("variant-picker") || document.body;
    if (!root || typeof MutationObserver === "undefined") return;
    var mo = new MutationObserver(function () {
      scheduleUnavailableOnly();
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    document.addEventListener("change", onDocChange, true);
    document.addEventListener("shopify:section:load", scheduleReapply);
    document.addEventListener("shopify:section:reorder", scheduleReapply);
    document.addEventListener("variant:selected", function () { variantPendingSince = Date.now(); }, true);
    document.addEventListener("variant:update", function () { variantPendingSince = 0; }, true);
    document.addEventListener("variant:update", scheduleUnavailableOnly);
    rebindButton();
    loadProductJson(function () {});
    applyUnavailableHide({ skipChange: false });
    startPoll();
    observePicker();
    var tries = 0;
    var id = setInterval(function () {
      tries += 1;
      rebindButton();
      applyUnavailableHide({ skipChange: true });
      if (document.querySelector("select.variant-option__select")) {
        /* keep trying briefly for late morph */
      }
      if (tries > 50) clearInterval(id);
    }, 200);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
